const getConfig = 'getConfig'
const save = 'save'
const changeMenu = 'changeMenu'
const changeLesson = 'changeLesson'
const toConfig = 'toConfig'
const next = 'next'
// 操作步骤
export const operationStep = {
  getConfig, // 先获取配置
  save, // 保存 走异步
  changeMenu, // 切换菜单
  changeLesson, // 切换课件课件
  toConfig, // 给cocos配置
  next, // 等待下一个动作触发
  qihuancaidan: [getConfig, changeMenu, changeLesson, toConfig, next]
}

export const configInfo = {
  moreInfo: '人家是有底线哦～'
}
// auth2.0 字段名
export const authCookie = {
  token: 'im-token',
  client_id: 'im-client-id'
}
// 提示语
export const warnType = {
  game: '游戏环节不支持该操作',
  ppt: '对不起，该功能无法与PPT功能，兼容使用。'
}
// 素材类型对应的枚举
export const enumTypeName = {
  '公共模式': '1',
  '公共游戏': '1',
  'C端游戏': '0',
  '我的': '0',
  'AI语音合成': '3'
}
// 提示语延迟时间弹出
export const openDelay = {
  nomal: 500,
  low: 2000,
  longh: 5000,
}
// 添加视频为背景 或 添加视频提示枚举
export const warnInfo = {
  addVideo: 'addVideo',
  addVideoBackground: 'addVideoBackground'
}
// 打包状态
export const packEnums = {
  unpublished: '未发布',
  run: '打包中',
  success: '成功',
  failure: '失败'
}

// 课件类型
export const updateEnums = {
  online: '线上课件',
  offline: '线下课件',
  double_teacher: '双师课件'
}

// 列表类型
export const LIST_TYPE = {
  myCourse: '我的课件',
  myTemplate: '我的模版',
  platTemplate: '公共模版'
}

// 文件类型
export const fileEnums = {
  image: '.png,.jpeg,.jpg',
  audio: '.mp3',
  video: '.mp4,.mov'
}

// 题库 - 类型枚举
export const articleTypeEmum = {
  all: '0', // 全部
  teach: '1', // 教材章节
  known: '2' // 知识点
}

// 题库 - 学科枚举
export const subjectEmum = {
  '1': '语文',
  '2': '数学',
  '3': '英语',
  '4': '物理',
  '5': '化学',
  '6': '生物',
  '7': '地理',
  '8': '历史',
  '9': '政治',
  '10': '奥数',
  '11': '新概念',
}

// 题库 - 年级枚举
export const gradeEmum = {
  '1': '小学',
  '2': '小学',
  '3': '小学',
  '4': '小学',
  '5': '小学',
  '6': '小学',
  '7': '初中',
  '8': '初中',
  '9': '初中',
  '10': '必修',
  '11': '选修',
  '18': '初中',
  '19': '高中',
  '66': '小学',
  '77': '初中',
  '88': '高中'
}

// 题库 - 困难度枚举
export const difficultyEmum = {
  '1': '容易',
  '2': '中等',
  '3': '较难'
}
